export enum VariantType {
  FIDES = 'fides',
  CREDIT_SUISSE = 'credit-suisse',
}
